import angular from 'angular'
import './lookup.service'

angular.module('admin.lookup', ['admin.lookup.service']).controller('LookupCtrl', LookupCtrl)

/** @ngInject */
function LookupCtrl($scope, LookupService, ChecklistService, SetsService, EventService) {
  var vm = this
  vm.items = []
  vm.channels = []
  vm.sets = []
  vm.collectibles = []
  vm.waitChannel = true
  vm.waitSet = true
  vm.customDate = false
  vm.chId = null
  vm.setId = null
  vm.collectibleId = null

  vm.isOpen = false

  var isDate = function(date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function(e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  function aftermaketStatus(item) {
    var coinsRestricted, cashRestricted

    var now = parseInt(
      new Date()
        .getTime()
        .toString()
        .concat('000'),
    )

    if (item.ra === true && (!item['ts-ra'] || item['ts-ra'] > now)) {
      coinsRestricted = true
    }
    if (item['ra-cash'] === true && (!item['ts-ra-cash'] || item['ts-ra-cash'] > now)) {
      cashRestricted = true
    }

    var status

    if (coinsRestricted) {
      if (cashRestricted) {
        status = 'Restricted'
      } else {
        status = 'Cash Only'
      }
    } else {
      if (cashRestricted) {
        status = 'Coins Only'
      } else {
        status = 'Not Restricted'
      }
    }

    return status
  }

  function reloadPagination() {
    vm.perPage = 25
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadChecklistPagination() {
    vm.perPage2 = 25
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  reloadPagination()
  reloadChecklistPagination()

  EventService.listChannels().then(function(result) {
    vm.channels = result.results
  })

  vm.search = function() {
    reloadPagination()
    vm.load(1)
  }

  vm.load = function(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    var collectibleId = !vm.collectibleId ? '' : vm.collectibleId
    if (!collectibleId) {
      collectibleId = vm.searchCollectibles
    }

    LookupService.list(vm.oldPage, 25, collectibleId).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].status = aftermaketStatus(result.results[i].s)
        result.results[i].loaded = false
      }

      vm.items = result.results
    })
  }

  vm.pageChanged = function(newPage) {
    vm.load(newPage)
    window.scrollTo({ top: 300, behavior: 'smooth' })
  }

  vm.loadActiveUsers = function(item) {
    LookupService.numberOfPrintsOwnedByActiveUsers(item.id).then(function(res) {
      item['cp-own'] = res.results['cp-own']
      item['cu-own'] = res.results['cu-own']
      item.loaded = true
    })
  }

  vm.loadChecklist = function(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    ChecklistService.listDraft(vm.oldPage2, 25, 'id-desc').then(function(result) {
      var items = result.results

      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }

      for (var i = 0; i < items.length; i++) {
        if (items[i].st) {
          if (items[i].st === 0) {
            items[i].status = 'Draft'
          } else if (items[i].st === 1) {
            items[i].status = 'Published'
          } else if (items[i].st === 2) {
            items[i].status = 'Archived'
          }
        }
        if (items[i]['ts-p'] !== undefined) {
          items[i]['ts-p'] = new Date(
            parseInt(
              items[i]['ts-p'].toString().substring(0, items[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (items[i]['ts-x'] !== undefined) {
          items[i]['ts-x'] = new Date(
            parseInt(
              items[i]['ts-x'].toString().substring(0, items[i]['ts-x'].toString().length - 3),
            ),
          )
        }

        var segTypes = []
        if (items[i].seg && items[i].seg.length > 0) {
          for (var x = 0; x < items[i].seg.length; x++) {
            var item = _.find(vm.usTypes, { id: items[i].seg[x].k })
            if (item) {
              segTypes.push(item.t)
            }
          }
        }

        items[i].segTypes = segTypes
      }

      vm.itemsChecklist = items
    })
  }

  vm.pageChangedChecklist = function(newPage) {
    vm.loadChecklist(newPage)
    $('#modalChecklists').animate({ scrollTop: 0 }, 800)
  }

  vm.showChecklists = function(item) {
    vm.itemSelected = item
    vm.loadChecklist(1)
    $('#modalChecklists').modal('show')
  }

  vm.showExpired = function(item) {
    vm.itemSelected = item
    $('#modalCloseCoin').modal('show')
  }

  vm.addToChecklist = function(id) {
    LookupService.addCollectibleToSegment(vm.itemSelected.id, { 'id-cd': id }).then(
      function() {
        vm.load(vm.pagination.current)
        $('#modalChecklists').modal('hide')
      },
      function(err) {
        if (_.isEmpty(err)) {
          swal('This Checklist doesn’t have a Collectible Ownership segment', '', 'error')
        } else {
          swal(err.error.message, '', 'error')
        }
      },
    )
  }

  vm.saveCloseCoin = function() {
    var expirationAt = vm.expirationAt
    if (expirationAt !== undefined && expirationAt !== '' && expirationAt !== null) {
      if (isDate(expirationAt)) {
        var date = parseInt(new Date(expirationAt).getTime() + '000')
        expirationAt = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    }

    swal(
      {
        title: 'Are you sure ?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          var model = {
            ra: true,
            'ts-ra': expirationAt,
          }

          SetsService.update2(vm.itemSelected['id-s'], model).then(
            function() {
              vm.load(vm.pagination.current)
              $('#modalCloseCoin').modal('hide')
            },
            function(err) {
              swal(err.error.message, '', 'error')
              return false
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.clear = function() {
    vm.chId = null
    vm.setId = null
    vm.collectibleId = null
    vm.items = []
    vm.sets = []
    vm.collectibles = []
    vm.waitChannel = true
    vm.waitSet = true
    reloadPagination()
  }

  var watch = $scope.$watch('vm.chId', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    EventService.listSets(newVal).then(function(response) {
      vm.sets = response.results
      vm.waitChannel = false
      vm.waitSet = true
      vm.collectibles = []
    })
  })

  var watch1 = $scope.$watch('vm.setId', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    vm.waitSet = false
    EventService.listCollectibles(vm.setId).then(function(response) {
      vm.collectibles = response.results
      vm.waitSet = false
    })
  })

  // var watch2 = $scope.$watch('vm.searchCollectibles', function(newVal, oldVal){
  //   if (newVal === oldVal) {
  //     return;
  //   }

  //   if (newVal === null || newVal === '') {
  //     if (oldVal) {
  //       reloadPagination();
  //       vm.load(1)
  //     }
  //     return;
  //   }

  //   if (newVal === false) {
  //     return;
  //   }

  //   if (vm.searchCollectibles.length < 2) {
  //     return;
  //   }

  //   reloadPagination();
  //   vm.load(1)
  // });

  $scope.$on('$destroy', function() {
    watch()
    watch1()
    // watch2();
  })

  vm.usTypes = [
    {
      id: 0,
      t: 'All',
    },
    {
      id: 2,
      t: 'Bundle',
    },
    {
      id: 1,
      t: 'Coin Product',
    },
    {
      id: 6,
      t: 'User',
    },
    {
      id: 3,
      t: 'Set',
    },
    {
      id: 5,
      t: 'Promo',
    },
    {
      id: 7,
      t: 'A/B Testing',
    },
    {
      id: 8,
      t: 'And Segment',
    },
    {
      id: 9,
      t: 'Xor Segment',
    },
    {
      id: 10,
      t: 'Not Segment',
    },
    {
      id: 11,
      t: 'Exclude Segment',
    },
    {
      id: 13,
      t: 'Listing',
    },
    {
      id: 14,
      t: 'Fyber',
    },
    {
      id: 15,
      t: 'Coin Wallet',
    },
    {
      id: 16,
      t: 'Coin Claim',
    },
    {
      id: 17,
      t: 'Collection Size',
    },
    {
      id: 18,
      t: 'Collectible Ownership',
    },
    {
      id: 19,
      t: 'Collection Value',
    },
    {
      id: 21,
      t: 'Region',
    },
    {
      id: 22,
      t: 'Language',
    },
  ]
}
